import React from 'react'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import { mainThemes, chatThemes } from 'utils/constants'
import ThemeList from './ThemeList'
import TooltipDropdown from '../TooltipDropdown'

const ThemeDropdown = ({ hasText = false }) => {
  const { pathname } = useRouter()
  const { activeChatTheme, activeTheme } = useSelector((state) => state.theme)

  const isChatPage = pathname === '/chat'
  const themesList = isChatPage ? chatThemes : mainThemes
  const activeThemeName = isChatPage ? activeChatTheme : activeTheme

  // const isDarkTheme = isChatPage && activeChatTheme !== 'theme5'

  // Find the active theme label to display
  // const activeThemeLabel = themesList.find((theme) => theme.value === activeThemeName)?.label || 'Theme'

  const trigger = (
    <div className="flex items-center gap-1 justify-center !cursor-pointer hover:opacity-90 transition-opacity">
      <img
        className={`w-6 h-6 cursor-pointer   ${activeChatTheme != 'theme5' ? 'invert' : ''}`}
        alt="theme"
        src={
          pathname == '/chat'
            ? activeChatTheme == 'theme5'
              ? '/assets/chat/moon.svg'
              : '/assets/chat/fill-moon.svg'
            : '/assets/chat/moon.svg'
        }
      />
      {hasText && <span>Themes</span>}
    </div>
  )

  return (
    <TooltipDropdown trigger={trigger} caretStyle={{ marginLeft: '55%' }} containerStyle={{ top: '-8px' }}>
      <ThemeList
        type={isChatPage ? 'chat' : 'main'}
        themesList={themesList}
        activeTheme={activeThemeName}
        onClose={() => {}}
      />
    </TooltipDropdown>
  )
}

export default ThemeDropdown
